import type { SxProps, Theme } from '@mui/material';
import { dynamicViewportHeight } from '../mixins';
import greenPalette from '../palettes/greenPalette';

export const CASINO_SIGN_IN_STYLES = {
  screen: {
    background: `radial-gradient(at center top, ${greenPalette.primary?.[600]} 0%, ${greenPalette.primary?.[900]} 100%)`,
    ...dynamicViewportHeight('minHeight', 'var(--header-height, 0px) + var(--mobile-bottom-nav-height, 0px)'),
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    p: { xs: 2, md: 4 },
  },
  form: {
    width: '100%',
    maxWidth: '444px',
    my: 'auto',
    backgroundColor: 'background.paper',
    '& form': { width: '100%' },
  },
} satisfies Record<string, SxProps<Theme>>;
